import Experience from './Experience/Experience'
import './style.scss'

window.experience = new Experience(document.querySelector('canvas.webgl'))